/**
 * Validación de selección para «Authorized Telegram users».
 * @param {Array<{ _id?: string, name?: string, email?: string, telegramUsername?: string }>} users
 */
export function normalizeTelegramUsernameForAllowlist(raw) {
  const s = String(raw || "")
    .trim()
    .replace(/^@+/, "")
    .toLowerCase();
  return s || "";
}

/**
 * @param {Array<{ _id?: string, name?: string, telegramUsername?: string }>} users
 * @returns {{ ok: boolean, duplicateUsernames: string[], withoutTelegram: Array<{ _id: string, name: string }> }}
 */
export function validateTelegramAllowlistSelection(users) {
  const list = Array.isArray(users) ? users : [];
  const seen = new Map();
  const duplicateUsernames = [];
  const withoutTelegram = [];

  for (const u of list) {
    if (!u || typeof u !== "object") continue;
    const uname = normalizeTelegramUsernameForAllowlist(u.telegramUsername);
    if (!uname) {
      withoutTelegram.push({
        _id: String(u._id || ""),
        name: String(u.name || u.email || u._id || ""),
      });
      continue;
    }
    if (seen.has(uname)) {
      duplicateUsernames.push(uname);
    } else {
      seen.set(uname, u);
    }
  }

  return {
    ok: duplicateUsernames.length === 0,
    duplicateUsernames: [...new Set(duplicateUsernames)],
    withoutTelegram,
  };
}
